var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.generalInspection
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page generalInspection-page",
            staticStyle: { margin: "0 auto", border: "0px solid #E8E8EC" },
            attrs: { id: "print_generalInspection" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  "font-size": "18px",
                  "font-weight": "600",
                },
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.model.generalInspection.hospitalName
                        ? _vm.model.generalInspection.hospitalName
                        : ""
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              { staticStyle: { "font-size": "15px", "font-weight": "600" } },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.model.generalInspection.reportName
                        ? _vm.model.generalInspection.reportName
                        : "体检报告"
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "15px",
                  "text-align": "left",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                  "border-bottom": "1px solid rgb(14, 14, 14)",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("学校："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.generalInspection.schoolName
                                  ? _vm.model.generalInspection.schoolName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.generalInspection.gradeName
                                  ? _vm.model.generalInspection.gradeName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.generalInspection.className
                                  ? _vm.model.generalInspection.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "25px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("编号："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.generalInspection.barCode
                                  ? _vm.model.generalInspection.barCode
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("体检日期："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.generalInspection
                                  .physicalExaminationDate
                                  ? _vm.model.generalInspection
                                      .physicalExaminationDate
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "25px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("姓名："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.generalInspection.name
                                  ? _vm.model.generalInspection.name
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("性别："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.generalInspection.sex
                                  ? _vm.model.generalInspection.sex
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年龄："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.generalInspection.age
                                  ? _vm.model.generalInspection.age
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "table",
                  width: "100%",
                  "line-height": "35px",
                  "text-align": "left",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "table-cell",
                      width: "50%",
                      "font-size": "15px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("身高")]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "table",
                          width: "100%",
                          "line-height": "25px",
                          gap: "30px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "table-cell",
                              width: "30%",
                            },
                          },
                          [
                            _c("span", [_vm._v("实测：")]),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.generalInspection.height
                                    ? _vm.model.generalInspection.height
                                    : ""
                                )
                              ),
                            ]),
                            _c("span", [_vm._v(" cm")]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "table-cell",
                              width: "30%",
                            },
                          },
                          [
                            _c("span", [_vm._v("评价：")]),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.generalInspection.heightEvaluation
                                    ? _vm.model.generalInspection
                                        .heightEvaluation
                                    : ""
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "table-cell",
                              width: "30%",
                            },
                          },
                          [
                            _c("span", [_vm._v("标准值：")]),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.generalInspection.standardHeight
                                    ? _vm.model.generalInspection.standardHeight
                                    : ""
                                )
                              ),
                            ]),
                            _c("span", [_vm._v(" cm")]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "table-cell",
                      width: "50%",
                      "font-size": "15px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("体重")]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "table",
                          width: "100%",
                          "line-height": "25px",
                          gap: "30px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "table-cell",
                              width: "30%",
                            },
                          },
                          [
                            _c("span", [_vm._v("实测：")]),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.generalInspection.weight
                                    ? _vm.model.generalInspection.weight
                                    : ""
                                )
                              ),
                            ]),
                            _c("span", [_vm._v(" kg")]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "table-cell",
                              width: "30%",
                            },
                          },
                          [
                            _c("span", [_vm._v("评价：")]),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.generalInspection.weightEvaluation
                                    ? _vm.model.generalInspection
                                        .weightEvaluation
                                    : ""
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "table-cell",
                              width: "30%",
                            },
                          },
                          [
                            _c("span", [_vm._v("标准值：")]),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.generalInspection.standardWeight
                                    ? _vm.model.generalInspection.standardWeight
                                    : ""
                                )
                              ),
                            ]),
                            _c("span", [_vm._v(" kg")]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._m(0),
            _c(
              "div",
              {
                staticStyle: {
                  padding: "8px 0px",
                  "border-bottom": "1px solid rgb(240, 239, 247)",
                  "text-align": "center",
                  "margin-top": "5px",
                },
              },
              [
                _vm._v("\n      体格发育评价："),
                _c("span", { staticStyle: { color: "rgb(244, 78, 74)" } }),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.model.generalInspection.physicalDevelopmentEvaluation
                    )
                  ),
                ]),
              ]
            ),
            _vm._m(1),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "10px",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                  "border-top": "1px solid #0E0E0EFF",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "line-height": "60px",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(2),
                          !_vm.model.generalInspection.adviceProgrammes ||
                          _vm.model.generalInspection.adviceProgrammes.length ==
                            0
                            ? _c("div", [_vm._v("未见异常")])
                            : _vm._e(),
                          _vm._l(
                            _vm.model.generalInspection.adviceProgrammes,
                            function (item, index) {
                              return _c("div", [
                                _c(
                                  "div",
                                  { staticStyle: { "font-size": "16px" } },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                                _c(
                                  "div",
                                  { staticStyle: { "line-height": "18px" } },
                                  [_vm._v(_vm._s(item.content))]
                                ),
                              ])
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "table",
          width: "100%",
          "text-align": "center",
          "margin-top": "10px",
        },
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              display: "table-cell",
              width: "50%",
              "margin-left": "30px",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "margin-left": "120px",
                  padding: "5px 0",
                  "font-size": "14px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "0 3px",
                      color: "rgb(91, 120, 221)",
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "blue",
                      staticStyle: {
                        padding: "0px 7px",
                        background: "rgb(250, 179, 63)",
                        margin: "0 3px",
                      },
                    }),
                    _vm._v("实测身高"),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "0 3px",
                      color: "rgb(91, 120, 221)",
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "yellow",
                      staticStyle: {
                        padding: "0px 7px",
                        background: "rgb(63, 139, 239)",
                        margin: "0 3px",
                      },
                    }),
                    _vm._v("标准身高"),
                  ]
                ),
              ]
            ),
            _c("div", {
              staticStyle: {
                "text-align": "center",
                width: "380px",
                height: "180px",
                "margin-left": "30px",
              },
              attrs: { id: "heightChart" },
            }),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "table-cell",
              width: "50%",
              "margin-left": "30px",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "typeTip",
                staticStyle: {
                  display: "flex",
                  "margin-left": "120px",
                  padding: "5px 0",
                  "font-size": "14px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "0 3px",
                      color: "rgb(91, 120, 221)",
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "blue",
                      staticStyle: {
                        padding: "0px 7px",
                        background: "rgb(250, 179, 63)",
                        margin: "0 3px",
                      },
                    }),
                    _vm._v("实测体重"),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "0 3px",
                      color: "rgb(91, 120, 221)",
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "yellow",
                      staticStyle: {
                        padding: "0px 7px",
                        background: "rgb(63, 139, 239)",
                        margin: "0 3px",
                      },
                    }),
                    _vm._v("标准体重"),
                  ]
                ),
              ]
            ),
            _c("div", {
              staticStyle: {
                "text-align": "center",
                width: "380px",
                height: "180px",
                "margin-left": "30px",
              },
              attrs: { id: "weightChart" },
            }),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          "margin-top": "15px",
          display: "table",
          width: "100%",
          "text-align": "center",
        },
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              display: "table-cell",
              width: "50%",
              "margin-left": "50px",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: { "margin-top": "10px", "margin-bottom": "10px" },
              },
              [_vm._v("身高发育监视图（cm）")]
            ),
            _c("div", {
              staticStyle: {
                "text-align": "center",
                width: "320px",
                height: "300px",
              },
              attrs: { id: "heightLineChart" },
            }),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "table-cell",
              width: "50%",
              "margin-left": "50px",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: { "margin-top": "10px", "margin-bottom": "10px" },
              },
              [_vm._v("体重发育监视图（kg）")]
            ),
            _c("div", {
              staticStyle: {
                "text-align": "center",
                width: "320px",
                height: "300px",
              },
              attrs: { id: "weightLineChart" },
            }),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "18px", "font-weight": "bold" } }, [
        _vm._v("医生建议"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }